/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const billingSubscriptionSchema = z.object({
  planKey: z.string(),
  status: z.string(),
  platform: z.string(),
  purchaseDate: z.number(),
  expiresDate: z.number().nullable(),
  autoRenewing: z.boolean(),
  environment: z.string(),
});

const billingPlanSchema = z.object({
  planKey: z.string(),
  displayName: z.string(),
  description: z.string().nullable(),
  type: z.string(),
  planLevel: z.number(),
  priceUsd: z.number(),
  intervalMonths: z.number().nullable(),
});

const billingProductSchema = z.object({
  id: z.string(),
  appleProductId: z.string(),
  googleProductId: z.string(),
  type: z.string(),
  planLevel: z.number(),
  displayName: z.string(),
  priceUsd: z.number(),
  discountedPriceUsd: z.number().nullable(),
});

const billingDiscountSchema = z.object({
  title: z.string(),
  type: z.enum(['percentage', 'amount']),
  value: z.number(),
});

export const getBillingStatusDataSchema = z.object({
  planName: z.string(),
  subscription: billingSubscriptionSchema.nullable(),
  plans: z.array(billingPlanSchema),
  products: z.array(billingProductSchema),
  discount: billingDiscountSchema.nullable(),
});

export type IGetBillingStatusData = z.infer<typeof getBillingStatusDataSchema>;

export const getBillingStatusResponseSchema = createApiResponseSchema(
  getBillingStatusDataSchema,
) as z.ZodSchema<IAPI<IGetBillingStatusData>>;

export type IGetBillingStatusResponse = IAPI<IGetBillingStatusData>;
